import { useState } from "react";
import { Pressable, StyleSheet, Text, View, Modal, Platform, Linking } from "react-native";

import { appColors } from "../constants/colors";

const SITE_URL = "https://www.instalmentcalculator.com";
const PRIVACY_URL = `${SITE_URL}/privacy-policy.html`;
const TERMS_URL = `${SITE_URL}/terms-of-service.html`;

export default function Footer() {
  const [showModal, setShowModal] = useState(false);
  const [pageName, setPageName] = useState();

  const open = name => {
    setPageName(name);
    setShowModal(true);
  };
  const close = () => setShowModal(false);

  // ─── Web: real anchor tags, crawlable, open the hosted HTML pages ───
  if (Platform.OS === "web") {
    return (
      <View style={styles.container}>
        <a href={PRIVACY_URL} style={webLinkStyle} target="_blank" rel="noopener noreferrer">
          Privacy Policy
        </a>

        <View style={styles.dot} />

        <a href={TERMS_URL} style={webLinkStyle} target="_blank" rel="noopener noreferrer">
          Terms of Service
        </a>
      </View>
    );
  }

  // ─── Native: opens the same hosted pages in the device browser ───
  return (
    <View style={styles.container}>
      <Pressable
        onPress={() => Linking.openURL(PRIVACY_URL)}
        style={({ pressed }) => [styles.link, pressed && styles.linkPressed]}
      >
        <Text style={styles.linkText}>Privacy Policy</Text>
      </Pressable>

      <View style={styles.dot} />

      <Pressable
        onPress={() => Linking.openURL(TERMS_URL)}
        style={({ pressed }) => [styles.link, pressed && styles.linkPressed]}
      >
        <Text style={styles.linkText}>Terms of Service</Text>
      </Pressable>
    </View>
  );
}

// Plain CSS object for the web <a> tags — React DOM accepts style objects directly
const webLinkStyle = {
  color: appColors.primaryLight,
  fontSize: 11,
  textDecoration: "none",
  paddingVertical: 4,
  paddingHorizontal: 6,
  borderRadius: 6,
  fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  fontWeight: "500",
};

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
    paddingVertical: 4,
  },

  link: {
    paddingVertical: 4,
    paddingHorizontal: 6,
    borderRadius: 6,
  },

  linkPressed: {
    backgroundColor: appColors.inputBg,
  },

  linkText: {
    color: appColors.primaryLight,
    fontSize: 11,
  },

  dot: {
    width: 3,
    height: 3,
    borderRadius: 1.5,
    backgroundColor: appColors.textMuted,
  },
});
